import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotNewsScroll from './components/HotNewsScroll';
import ArticleGrid from './components/ArticleGrid';
import CommentSection from './components/CommentSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotNewsScroll />
        <ArticleGrid />
        <CommentSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}